import { render, staticRenderFns } from "./ResourceIndex.vue?vue&type=template&id=4b25a55f&"
import script from "./ResourceIndex.vue?vue&type=script&lang=js&"
export * from "./ResourceIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b25a55f')) {
      api.createRecord('4b25a55f', component.options)
    } else {
      api.reload('4b25a55f', component.options)
    }
    module.hot.accept("./ResourceIndex.vue?vue&type=template&id=4b25a55f&", function () {
      api.rerender('4b25a55f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/ResourceIndex.vue"
export default component.exports